import * as React from 'react';
import { Box, Container, Grid } from '@material-ui/core';
import { LeftFooter } from './components/LeftFooter';
import { RightFooter } from './components/RightFooter';
import { bokunTheme } from '../../index';

export const Footer = () => {
    return (
        <Box component={'footer'} bgcolor={bokunTheme.light}>
            <Container>
                <Box p={4} py={6}>
                    <Grid container>
                        <Grid xs={12} sm={6} item>
                            <LeftFooter />
                        </Grid>
                        <Grid xs={12} sm={6} item>
                            <RightFooter />
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </Box>
    );
};
